import '../assets/NcActionRadio-CROsOVZe.css';
import { g as mdiRadioboxMarked, h as mdiRadioboxBlank } from "./mdi-DkJglNiS.mjs";
import Vue from "vue";
import { N as NcIconSvgWrapper } from "./NcIconSvgWrapper-Bui9PhAS.mjs";
import { u as useModelMigration } from "./useModelMigration-EhAWvqDD.mjs";
import { A as ActionGlobalMixin } from "./actionGlobal-DqVa7c7G.mjs";
import { G as GenRandomId } from "./GenRandomId-F5ebeBB_.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const _sfc_main = {
  name: "NcActionRadio",
  components: {
    NcIconSvgWrapper
  },
  mixins: [ActionGlobalMixin],
  inject: {
    isInSemanticMenu: {
      from: "NcActions:isSemanticMenu",
      default: false
    }
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    /**
     * id attribute of the radio element
     */
    id: {
      type: String,
      default: () => "action-" + GenRandomId(),
      validator: (id) => id.trim() !== ""
    },
    /**
     * Removed in v9 - use `modelValue` (`v-model`) instead
     *
     * @deprecated
     */
    checked: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default
      default: void 0
    },
    /**
     * Checked state of the radio element
     * Boolean type removed in v9 - use String | Number instead
     */
    modelValue: {
      type: [Boolean, String, Number],
      default: false
    },
    /**
     * Define if this radio is part of a set.
     * Checking the radio will disable all the
     * others with the same name.
     */
    name: {
      type: String,
      required: true
    },
    /**
     * value of the radio input
     */
    value: {
      type: [String, Number],
      default: ""
    },
    /**
     * disabled state of the radio element
     */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    /**
     * Removed in v9 - use `update:modelValue` (`v-model`) instead
     *
     * @deprecated
     */
    "update:checked",
    /**
     * The radio state is changed
     *
     * @type {boolean}
     */
    "update:modelValue",
    /** Same as update:modelValue for Vue 2 compatibility */
    "update:model-value",
    "change"
  ],
  setup(props) {
    if (typeof props.modelValue === "boolean") {
      Vue.util.warn("[NcActionRadio] Boolean type of `modelValue` is deprecated and will be removed in next versions");
    }
    const model = useModelMigration("checked", "update:checked");
    return {
      model,
      mdiRadioboxBlank,
      mdiRadioboxMarked
    };
  },
  computed: {
    isChecked() {
      return this.model === this.value;
    }
  },
  methods: {
    toggleInput() {
      this.$refs.label.click();
    },
    onChange(event) {
      this.$emit("change", event);
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("li", { staticClass: "action", class: { "action--disabled": _vm.disabled }, attrs: { "role": _vm.isInSemanticMenu && "presentation" } }, [_c("label", { staticClass: "action-radio", attrs: { "role": _vm.isInSemanticMenu && "menuitemradio", "aria-checked": _vm.isInSemanticMenu && _vm.isChecked.toString() } }, [_c("span", { staticClass: "action-radio__icon" }, [_c("input", { directives: [{ name: "model", rawName: "v-model", value: _vm.model, expression: "model" }], staticClass: "action-radio__input", class: { focusable: !_vm.disabled }, attrs: { "id": _vm.id, "type": "radio", "name": _vm.name, "disabled": _vm.disabled }, domProps: { "value": _vm.value, "checked": _vm._q(_vm.model, _vm.value) }, on: { "change": [function($event) {
    _vm.model = _vm.value;
  }, function($event) {
    return _vm.$emit("change", $event);
  }] } }), _c("NcIconSvgWrapper", { attrs: { "path": _vm.isChecked ? _vm.mdiRadioboxMarked : _vm.mdiRadioboxBlank, "size": 20 } })], 1), _c("span", { staticClass: "action-radio__text" }, [_vm._v(_vm._s(_vm.text))])])]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "a3f0f3fe"
);
const NcActionRadio = __component__.exports;
export {
  NcActionRadio as N
};
//# sourceMappingURL=NcActionRadio-Dd3CsuiD.mjs.map
